import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["form", "invalidInputError", "previewContainer", "submitButton"];

  static values = { url: String };

  preview(event) {
    event.preventDefault();

    if (!this._fileUploaded()) {
      this._clearError();
      this._clearPreview();
      this.submitButtonTarget.disabled = true;

      return
    }

    const body = new FormData(this.formTarget);

    Rails.ajax({
      url: this.urlValue,
      type: 'POST',
      data: body,
      dataType: 'script',
      beforeSend: (xhr) => {
        this._overlayController()?._showLoadOverlay();
        this.ajaxRequest = xhr;
        return true;
      },
      success: () => { this._overlayController()?._hideLoadOverlay(); },
      error: () => { this._overlayController()?._hideLoadOverlay(); },
    });
  }

  _overlayController() {
    return this.application.getControllerForElementAndIdentifier(document.body, 'overlay');
  }

  _fileUploaded() {
    const fileInputElement = this.formTarget.querySelector("input[type='file']");

    return fileInputElement.files.length > 0;
  }

  _clearError() {
    this.invalidInputErrorTarget.innerHTML = "";
  }

  _clearPreview() {
    this.previewContainerTarget.innerHTML = "";
  }
}
